import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'FaqSearch',

  components: {
    ShButton,
  },

  props: [],

  data() {
    return {
      searchText: null,
    };
  },

  computed: {
    keywordSearch() {
      return this.$store.getters['settings/keywordSearchInFaqList'];
    },
  },

  methods: {
    addSearchKeyword() {
      this.$store.commit('settings/ADD_SEARCH_KEYWORD_IN_FAQ_LIST', this.searchText.toLowerCase());
      this.searchText = null;
    },
    deleteSearchKeyword(keyword) {
      this.$store.commit('settings/REMOVE_SEARCH_KEYWORD_IN_FAQ_LIST', keyword);
    },
    cleareSearchKeywords() {
      this.$store.commit('settings/CLEAR_SEARCH_KEYWORDS_IN_FAQ_LIST');
    },
  },
};
